import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum SubScopeOfWork {
  ProgressReportsOnly = 'progress-reports-only',
  ResponsibleForProducts = 'responsible-for-products',
  PtePiWorkDependsOnSub = 'pte-pi-work-depends-on-sub',
  PteWorkDependsOnSubPerformance = 'pte-work-depends-on-sub-performance',
}

const SUBCONTRACT_PERCENTS: ReadonlySet<SubScopeOfWork> = new Set(
  Object.values(SubScopeOfWork) as SubScopeOfWork[],
)
export namespace SubScopeOfWork {
  export const ALL: readonly SubScopeOfWork[] = Array.from(SUBCONTRACT_PERCENTS)
  export const isSubScopeOfWork =
    TypeChecker.Factory.oneOf(SUBCONTRACT_PERCENTS)
  export const assertIsSubScopeOfWork: TypeAsserter<SubScopeOfWork> =
    TypeAsserter.Factory.from(isSubScopeOfWork)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link SubScopeOfWork}
   */
  export function getEntry(
    subScopeOfWork: SubScopeOfWork,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[subScopeOfWork], id: subScopeOfWork }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    SubScopeOfWork,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [SubScopeOfWork.ProgressReportsOnly]: {
      name: 'Subrecipient will only submit progress reports',
    },
    [SubScopeOfWork.ResponsibleForProducts]: {
      name: 'Subrecipient is responsible for tangible products',
    },
    [SubScopeOfWork.PtePiWorkDependsOnSub]: {
      name: "PTE's PI's work is dependent upon Subrecipient's work",
    },
    [SubScopeOfWork.PteWorkDependsOnSubPerformance]: {
      name: `PTE's work is dependent upon Sub's & continuation funding is tied to performance`,
    },
  }
}
